var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTextHelp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 33,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 33"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1F2124",
  d: "M16 12.241a3 3 0 1 0-3-3q0 .108-.02.203A1 1 0 0 1 11 9.24a5 5 0 1 1 6 4.9v2.1a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1M16 19.241a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1F2124",
  fillRule: "evenodd",
  d: "M4.268 31.858a36.4 36.4 0 0 0 10.08-5.617H21c6.075 0 11-4.925 11-11v-4c0-6.075-4.925-11-11-11H11c-6.075 0-11 4.925-11 11v4c0 3.264 1.432 6.292 3.851 8.361q-.48 2.774-1.537 6.43a1.5 1.5 0 0 0 1.954 1.826m9.381-7.617-.274.22a34.5 34.5 0 0 1-8.868 5.167q.985-3.55 1.414-6.282l.092-.588-.473-.362A8.98 8.98 0 0 1 2 15.241v-4a9 9 0 0 1 9-9h10a9 9 0 0 1 9 9v4a9 9 0 0 1-9 9z",
  clipRule: "evenodd"
})));
export default SvgTextHelp;